import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import { select, Store} from '@ngrx/store';
import {catchError, filter, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {error, success} from '../../shared/actions/toasts';
import {BaseEffect} from '../../shared/effects/base.effect';
import {debug} from '../../../rxjs-operators';
import * as fromShared from '../../shared/reducers';
import {of} from 'rxjs';
import {ArrayResponse, SendBackResult} from '../../shared';
import {
  playerConfigurationUpdateActionTypes,
  UpdatePlayerConfigurationAction, UpdatePlayerConfigurationFailAction,
  UpdatePlayerConfigurationSuccessAction
} from '../actions/player-configuration-update';
import {PlayerConfigurationEdit} from '../models/player-configuration';
import {PlayerConfigurationEditService} from '../services/player-configuration-edit.service';
import {PlayerConfigMapperService} from '../services/player-config-mapper.service';
import * as fromRoot from '../reducers';
import * as _ from 'lodash';
import * as fromSite from '../../site/reducers';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class PlayerConfigurationUpdateEffect extends BaseEffect {
  private currentClient$ = this.store.pipe(select(fromRoot.selectors.getCurrentClient), filter(client => !_.isEmpty(client)));
  private site$ = this.store.pipe(select(fromSite.selectors.getSite), filter(state => !_.isEmpty(state)));
  private playerConfig$ = this.store.pipe(select(fromRoot.selectors.getPlayerConfigurationEdit));


  update$ = createEffect(() => { return this.actions$.pipe(
    ofType(playerConfigurationUpdateActionTypes.UPDATE),
    debug('update player configuration action received.'),
    map((action: UpdatePlayerConfigurationAction) => action.payload),
    withLatestFrom(this.currentClient$, this.site$ , this.playerConfig$),
    switchMap(([payload, client, site , playerConfig]) =>
      this.playerConfigurationService.update(client.uuid, site.subscriptions[0].uuid ,
        this.playerConfigMapperService.formToDb(payload.form , payload.config , playerConfig)).pipe(
        switchMap((payloadR: SendBackResult<ArrayResponse<PlayerConfigurationEdit>>) => of(new UpdatePlayerConfigurationSuccessAction(payloadR.data.array))),
        catchError(res => this.catchResponseError(res)))))
  });

  updateClient$ = createEffect(() => { return this.actions$.pipe(
    ofType(playerConfigurationUpdateActionTypes.UPDATE_CLIENT),
    debug('update player configuration action received.'),
    map((action: UpdatePlayerConfigurationAction) => action.payload),
    withLatestFrom(this.currentClient$, this.playerConfig$),
    switchMap(([payload, client , playerConfig]) =>
      this.playerConfigurationService.updateClient(client.uuid, this.playerConfigMapperService.formToDb(payload.form , payload.config , playerConfig)).pipe(
        switchMap((payloadR: SendBackResult<ArrayResponse<PlayerConfigurationEdit>>) => of(new UpdatePlayerConfigurationSuccessAction(payloadR.data.array))),
        catchError(res => this.catchResponseError(res)))))
  });


  update$Success$ = createEffect(() => { return this.actions$.pipe(
    ofType(playerConfigurationUpdateActionTypes.UPDATE_SUCCESS),
    debug('update success player configuration action received.'),
    withLatestFrom(this.store.pipe(select(fromShared.selectors.getCurrentClient))),
    switchMap(([data, client]) => [
      success(this.translation.translate('PLAYER_CONFIG_UPDATE_SUCCESS'), this.translation.translate('TOAST_SUCCESS_TITLE'))
    ]),
  )});


  update$Fail$ = createEffect(() => { return this.actions$.pipe(ofType(playerConfigurationUpdateActionTypes.UPDATE_FAIL),
    debug('A server error occurred while update player configuration.'),
    map((err: UpdatePlayerConfigurationFailAction) =>
      error(this.translation.translate('PLAYER_CONFIG_UPDATE_ERROR') + ' ' + err.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private playerConfigurationService: PlayerConfigurationEditService,
              private playerConfigMapperService: PlayerConfigMapperService,
              private store: Store<fromShared.AppState>,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new UpdatePlayerConfigurationFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new UpdatePlayerConfigurationFailAction(response['error'].message);
  }
}
